import _ from 'lodash';
import SmsService from 'web-core/src/sms-service';

import {
  SMS_REQUEST_SENT,
  SMS_RESPONSE_RECEIEVED,
  SMS_SEND_FAILED,
} from '../constants/sms';

const smsRequestSent = key => ({
  type: SMS_REQUEST_SENT,
  key,
});

const smsResponseReceieved = (key, phone) => ({
  type: SMS_RESPONSE_RECEIEVED,
  key,
  phone,
});

const smsSendFailed = (key, payload) => ({
  type: SMS_SEND_FAILED,
  key,
  payload,
});

export const sendSms = ({ key, url, payload }) => (
  (dispatch, getState, { apiClient }) => {
    const state = getState();
    const isPending = !!_.find(state.sms.pending, key);
    if (isPending) {
      return Promise.reject('Request pending');
    }

    const existing = _.find(state.sms.received, { key });
    if (existing) {
      return Promise.resolve(existing.data);
    }

    dispatch(smsRequestSent(key));

    const smsService = new SmsService({ client: apiClient });
    return smsService.send(url, payload)
      .then((data) => {
        dispatch(smsResponseReceieved(key, payload.phone));
        return data;
      })
      .catch((error) => {
        dispatch(smsSendFailed(key, payload));
        return Promise.reject(error);
      });
  }
);
